<template>
    <card title="Seguimiento HotExpress" icon="list-alt">
        <form @submit.prevent="search">
            <div class="card mt-4">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for>Centro de costo:</label>
                                    <input v-model="filters.costCenter" class="form-control" type="text" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for>N° Guía:</label>
                                    <input v-model="filters.guideNumber" class="form-control" type="text" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for>Agente:</label>
                                    <input v-model="filters.agentName" class="form-control" type="text" />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="align-items-end">
                                <div class="form-group col">
                                    <div class="mt-4 text-right">
                                        <button type="submit" class="btn btn-dark ml-2 mt-2">
                                            <i class="fa fa-search mr-2"></i>Buscar
                                        </button>
                                        <button class="btn btn-dark ml-2 mt-2" type="button" @click="reset">
                                            <i class="fa fa-sync-alt mr-2"></i>Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div v-if="trackings.length > 0" class="table table-responsive mt-4">
            <table class="table table-hover table-striped table-bordered">
                <thead>
                    <tr class="bg-dark text-white">
                        <th>Fcom</th>
                        <th>Centro de costo</th>
                        <th>N° Guía</th>
                        <th>Agente</th>
                        <th>Estado</th>
                        <th>Detalle Estado</th>
                        <th>Fecha de creación</th>
                        <th>Fecha de actualización</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="tracking in trackings" :key="tracking.id">
                        <td>
                            <router-link v-if="tracking.requestCommercialSampleId" :to="`/solicitudes/visualizar/${tracking.requestCommercialSampleId}`" class="btn btn-info btn-sm ml-2">
                                {{ tracking.requestCommercialSampleId}}
                            </router-link>
                        </td>
                        <td>{{ tracking.costCenter }}</td>
                        <td>{{ tracking.guideNumber }}</td>
                        <td>{{ tracking.agentName }}</td>
                        <td>{{ tracking.status }}</td>
                        <td>{{ tracking.guideStatus }}</td>
                        <td>{{ tracking.createDateString }}</td>
                        <td>{{ tracking.updatedDateString }}</td>
                        <td class="text-right">
                            <router-link v-if="tracking.hotExpressTrackingsCount > 0" :to="{ name: 'HotExpressTrackingDetail', params: { id: tracking.id } }"
                                class="btn btn-primary btn-sm">
                                <i class="fa fa-eye"></i>
                            </router-link>
                            <a v-if="tracking.url" title="Seguimiento Externo" target="_blank" @click.prevent="copyAndRedirect(tracking.guideNumber, tracking.url)" class="btn btn-warning ml-2 btn-sm"><i class="fas fa-plane-departure"></i></a>

                        </td>
                    </tr>
                </tbody>
            </table>
            <paginator :links="links" class="mt-4"></paginator>
        </div>
    </card>
</template>

<script>
import { Get } from '../../helper/axios';
import { getUrlQuery } from "../../helper/queryHelper";

export default {
    name: "HotExpressTracking",
    watch: {
        urlQuery: function () {
            this.index();
        },
    },
    data() {
        return {
            Get,
            apiUrl: this.$store.getters.apiUrl,
            getUrlQuery,
            filters: {
                'costCenter': '',
                'agenName': '',
                'guideNumber': ''
            },
            trackings: [],
            links: {},
        };
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.Get(this.apiUrl + "v1/hotexpressguidenumbers?" + this.urlQuery, (res) => {
                this.trackings = res.data.data;
                this.links = res.data.links;
                this.$store.commit("setLoading", false);
            });
        },
        search() {
            this.$store.commit("setLoading", true);
            this.$router.push({
                path: this.$route.path,
                query: this.filters,
            });
            this.index();
        },
        reset() {
            if (this.$route.fullPath != "/") {
                this.filters = {};
                this.stateModel = "";
                this.search();
            }
        },
        copyAndRedirect (text, url) {
            try {
                navigator.clipboard.writeText(text);
            } catch (err) {
                console.error('Error al copiar: ', err);
            }

            window.open(url, '_blank');
        },
    },
    computed: {
        urlQuery() {
            return this.getUrlQuery();
        },

    }
}
</script>